import styled from "styled-components";

export const Row = styled.div`
  color: #5a2800;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  margin: 1.5rem 0;
`;

export const Heading = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Martel;
  color: #5a2800;
  font-size: 3.5rem;
  text-transform: capitalize;
`;

export const Description = styled.div`
  font-size: 1.05rem;
  max-width: 98%;
  padding-left: 1rem;
`;

export const FirstLetter = styled.span`
  font-family: Martel;
  font-size: 2.5rem;
  line-height: 1rem;
`;

export const Parapgraph = styled.div`
  font-size: 1.05rem;
  margin-top: 1rem;
  a {
    text-decoration: none;
    font-weight: bold;
  }
`;
